export const cart = {};



// WEBPACK FOOTER //
// ./app/js/modules/vue/modules/sidecart.js